import { render, staticRenderFns } from "./resultunit-total.vue?vue&type=template&id=061dbce3&scoped=true"
import script from "./resultunit-total.vue?vue&type=script&lang=js"
export * from "./resultunit-total.vue?vue&type=script&lang=js"
import style0 from "./resultunit-total.vue?vue&type=style&index=0&id=061dbce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061dbce3",
  null
  
)

export default component.exports